import { FC } from "react";
import { Row, Typography, Tooltip } from "antd";
import { StyledTag, StyledText } from "./styled";
import { isBoolean } from "../../utils";
import { TWDCardElement } from "../../types";

interface WDCardBodyElementProps {
  dateOrStatus: TWDCardElement;
  isHighlighted?: boolean;
  text: string;
  tooltipText?: string;
}

export const WDCardBodyElement: FC<WDCardBodyElementProps> = ({
  dateOrStatus,
  isHighlighted,
  text,
  tooltipText,
}) => (
  <Row align="middle" justify="space-between">
    <Typography.Text style={{marginTop: "4px"}} color={"#8c8c8c"}>{text}</Typography.Text>

    <Tooltip overlay={tooltipText}>
      {isBoolean(dateOrStatus) ? (
        <StyledTag
          color={dateOrStatus ? "#51AD77" : "#faad14"}
          $textColor={dateOrStatus ? "#FFFFFF" : "#FFFFFF"}
        >
          {dateOrStatus ? "Принято" : "Ожидание"}
        </StyledTag>
      ) : (
        <StyledText
          $backgroundColor={isHighlighted ? "#51AD77" : "inherit"}
          color={isHighlighted ? "#FFFFFF" : "#595959"}
        >
          {dateOrStatus}
        </StyledText>
      )}
    </Tooltip>
  </Row>
);
